// language=GraphQL
export const ALL_CALCULATION_SETTINGS_QUERY = `query Query {
  calculationSettings: allTravelPricingServiceCalculationSettings {
    id
    type
    considerHotelNights
  }
}`

// language=GraphQL
export const SINGLE_CALCULATION_SETTINGS_QUERY = `query Query($id: ID!) {
  calculationSettings: travelPricingServiceCalculationSettings(id: $id) {
    id
    type
    considerHotelNights
  }
}`

// language=GraphQL
export const CREATE_CALCULATION_SETTINGS_MUTATION = `
  mutation Mutation($input: CreateTravelPricingServiceCalculationSettingsInput) {
    calculationSettings: createTravelPricingServiceCalculationSettings(input: $input) {
      id
      type
      considerHotelNights
    }
  }`

// language=GraphQL
export const UPDATE_CALCULATION_SETTINGS_MUTATION = `
  mutation Mutation($input: UpdateTravelPricingServiceCalculationSettingsInput) {
    calculationSettings: updateTravelPricingServiceCalculationSettings(input: $input) {
      id
      type
      considerHotelNights
    }
  }`

// language=GraphQL
export const DELETE_CALCULATION_SETTINGS_MUTATION = `
  mutation Mutation($input: DeleteTravelPricingServiceCalculationSettingsInput) {
    deleteTravelPricingServiceCalculationSettings(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_CALCULATION_SETTINGS_MUTATION = `
  mutation Mutation($input: DeleteTravelPricingServiceCalculationSettingsInput) {
    forceDeleteTravelPricingServiceCalculationSettings(input: $input) {
      success
    }
  }`
// language=GraphQL
export const CALCULATION_SETTINGS_DEPENDENTS_QUERY = `query Query($id: ID!, $withRatioPersonalAddons: Boolean = false, $withRatioAccommodationAddons: Boolean = false, $withRatioBookingAddons: Boolean = false, $withRatioCollectiveAddons: Boolean = false) {
  groupedDependents: travelPricingServiceCalculationSettingsDependents(id: $id) {
    ratioPersonalAddons @include(if: $withRatioPersonalAddons) {
      id
      ratioServiceNo
      name
      label
      info
    }
    ratioAccommodationAddons @include(if: $withRatioAccommodationAddons) {
      id
      ratioServiceNo
      name
      label
      info
    }
    ratioBookingAddons @include(if: $withRatioBookingAddons) {
      id
      ratioServiceNo
      name
      label
      info
    }
    ratioCollectiveAddons @include(if: $withRatioCollectiveAddons) {
      id
      label
      info
    }
  }
}`
